module.exports = __webpack_public_path__ + "img/Beast.d5f713b3.png";